import WorldView from '@/views/worldView/index'

export default WorldView